import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Entry, JurorSelection } from '../entry';
import { EntryService } from '../entry.service';
import { Stats } from '../stats';

@Component({
  selector: 'app-jurormenu',
  templateUrl: './jurormenu.component.html',
  styleUrls: ['./jurormenu.component.less']
})
export class JurorMenuComponent implements OnInit {
  title = 'WW55';
  entry: Entry;
  current = 0;
  stats: Stats;

  constructor(private entryService: EntryService, public router: Router) { }

  getEntries(): void {
    this.entry = this.entryService.entries[0];
    // console.log("getEntries" + this.entryService.entries.length);
    // console.log(this.entry);
  }

  ngOnInit(): void {
    this.getEntries();
    this.stats = this.entryService.stats;
  }

  onNavChanged(pos: number): void {
    if (pos === -1) {
      this.current = pos;
      this.entry = null;
    } else {
      this.current = pos;
      this.entry = this.entryService.entries[pos];
    }
  }

  onJurorSelection(selection: JurorSelection): void {
    // DISABLED
    console.log(selection);
    this.entryService.rateEntry(this.current, selection);
  }

}
